import { readStateFromSearch, writeStateToSearch, describeActiveFilters } from './dealerStockFilters';

// How the shared SavedSearches panel reads Dealer Stock saved searches:
// { name, query, notifyEnabled, createdAt }, kept in the user's savedDealerSearches.
// `query` is the page's own query string for the filters and search text, without
// sort, page or page size, so running a saved search is navigating to it and the
// alert job can hand the same filters to the dealer API.

const toQuery = (filters, search) => writeStateToSearch({ filters, search }).replace(/^\?/, '');

const readQuery = (query) => readStateFromSearch(query ? `?${query}` : '');

/** The search on screen, in saved-search shape. */
export const dealerCurrentSearch = (filters, search) => ({ query: toQuery(filters, search) });

export const dealerSavedSearchAdapter = {
  field: 'savedDealerSearches',
  collapsedKey: 'dealerSavedSearchesCollapsed',
  carsLabel: 'dealer cars',
  listingsLabel: 'dealer listings',

  // Re-written through the page's own serializer, so a saved query matches the URL
  // whatever order its parameters were stored in.
  keyOf: (entry) => {
    const { filters, search } = readQuery(entry.query);
    return toQuery(filters, search);
  },

  // The same labels as the page's active-filter chips, search text first.
  describe: (entry) => {
    const { filters, search } = readQuery(entry.query);
    return [...(search ? [search] : []), ...describeActiveFilters(filters, '').map((chip) => chip.label)];
  },
};
